const META_PIXEL_ID = '4216370705320258';

let initialized = false;

export function isMarketplacePath(pathname = '') {
  return pathname === '/marketplace' || pathname.startsWith('/marketplace/');
}

export function isMetaPixelPath(pathname = '') {
  if (isMarketplacePath(pathname)) return true;
  return pathname === '/register' || pathname.startsWith('/register/') || pathname === '/complete-profile';
}

function fbq() {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq.apply(window, arguments);
  }
}

export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return;
  initialized = true;

  if (!window.fbq) {
    const n = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    n.queue = [];
    n.loaded = true;
    n.version = '2.0';
    n.push = n;
    window.fbq = n;
    window._fbq = n;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const first = document.getElementsByTagName('script')[0];
    first.parentNode.insertBefore(script, first);
  }

  fbq('init', META_PIXEL_ID);

  if (!document.getElementById('meta-pixel-noscript')) {
    const noscript = document.createElement('noscript');
    noscript.id = 'meta-pixel-noscript';
    noscript.innerHTML =
      `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" alt="" />`;
    document.body.appendChild(noscript);
  }
}

export function trackMetaPageView() {
  fbq('track', 'PageView');
}

export function trackMetaViewContent(product) {
  if (!product) return;
  fbq('track', 'ViewContent', {
    content_ids: [product.slug || product.id].filter(Boolean),
    content_name: product.title || '',
    content_type: 'product',
    value: Number(product.price) || 0,
    currency: product.currency || 'MAD',
  });
}

export function trackMetaAddToCart(product, qty = 1) {
  if (!product) return;
  const amount = Math.max(1, Number(qty) || 1);
  fbq('track', 'AddToCart', {
    content_ids: [product.slug || product.id].filter(Boolean),
    content_name: product.title || '',
    content_type: 'product',
    value: (Number(product.price) || 0) * amount,
    currency: product.currency || 'MAD',
    contents: [{ id: product.slug || product.id, quantity: amount }],
  });
}

export function trackMetaPurchase(order, items = []) {
  const value = Number(order?.total) || 0;
  fbq('track', 'Purchase', {
    value,
    currency: order?.currency || 'MAD',
    content_type: 'product',
    content_ids: items.map((item) => item.slug).filter(Boolean),
    num_items: items.reduce((sum, item) => sum + (Number(item.qty) || 0), 0),
  });
}

export function trackMetaCompleteRegistration(method = 'form') {
  fbq('track', 'CompleteRegistration', {
    content_name: 'saas_signup',
    status: true,
    method,
  });
}
